import { Center, Loader } from '@mantine/core';

interface PendingSpinnerProps {
  h?: string | null;
}

export function PendingSpinner({ h }: PendingSpinnerProps) {
  return (
    <Center h={h ?? '60vh'}>
      <Loader color="primary" />
    </Center>
  );
}
